<template>
 <b-overlay :show="showoverlay" rounded="sm">
    <div class="">
        <div class="" id="nav-tabContent-intro">
            <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">KPI Reports<span>
                <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / KPI Reports</span>
            </h4>
            <p style="font-size: 15px;" class="text-secondary pt-4">Get a clear picture of your Loan & Advance. Use this information to better understand your workforce.</p>

            <template v-if="$atl_company_package_title != 'Provident Fund Only'">


                <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav">
                    <b-tab>
                        <!-- <template #title>
                            <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                <img v-bind:src="$api_url+'/images/Monthly-report-black.png'"
                                    class="light-mode-icon" width="50px"/><img
                                v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon"
                                width="50px"/>Salary Reviews
                            </div>
                            <div class="report-intro">
                            This report highlights employees information, employment history, benefits, salary reviews, clear snapshot of their professional journey within the organization.
                            </div>
                            <b-button @click="downloadReport" class="mt-3">Download</b-button>
                        </template> -->
                        <template #title>
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                                <h5>Salary Reviews</h5>
                                <p>This report highlights employees information, employment history, benefits, salary reviews, clear snapshot of their professional journey within the organization.</p>
                                <b-button @click="downloadReport" class="btn btn-primary">Download</b-button>
                            </div>
                        </template>
                    </b-tab>
                    <b-tab>
                        <!-- <template #title>
                            <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                <img v-bind:src="$api_url+'/images/Yearly-report-black.png'"
                                    class="light-mode-icon" width="50px"/><img
                                v-bind:src="$api_url+'/images/Yearly-report.png'" class="dark-mode-icon"
                                width="50px"/>Monthly Summary
                            </div>
                            <div class="report-intro">
                            This report outlines employees' details, benefits, and history for the recent period, with a suggested timeline for the next review.
                            </div>
                            <b-button class="mt-3">View</b-button>
                        </template> -->
                        <template #title>
                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+'/images/Yearly-report-black.png'" class="light-mode-icon"/>
                                <h5>Monthly Summary</h5>
                                <p>This report outlines employees' details, benefits, and history for the recent period, with a suggested timeline for the next review.</p>
                                <b-button class="btn btn-primary">View Report</b-button>
                            </div>
                        </template>
                        <div class="ibox py-2">
                            <b-form @submit.prevent="getReport">
                                <div class="row mt-4 mb-5">
                                    <div class="col-sm-5 mb-3 company-form-box-title row no-margin"> <!-- Mustafijur: 13-05-2026 -->
                                        <div class="col-sm-3 d-flex align-items-center text-right justify-content-end">Month</div><!-- Mustafijur: 13-05-2026 -->
                                        <div class="col-sm-9"> <!-- Mustafijur: 13-05-2026 -->
                                            <b-form-select
                                                id="start_month"
                                                name="start_month"
                                                data-vv-as="Month"
                                                :state="validateState('start_month')"
                                                v-validate="{ required: true }"
                                                aria-describedby="start_month-feedback"
                                                v-model="fData.start_month">
                                                <b-form-select-option
                                                    v-for="(month, n) in months"
                                                    :key="n"
                                                    :value="month.value">
                                                    {{month.text}}
                                                </b-form-select-option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="start_month-feedback">
                                                {{ veeErrors.first('start_month') }}
                                            </b-form-invalid-feedback>
                                        </div>
                                    </div>
                                    <div class="col-sm-5 mb-3 company-form-box-title row no-margin"> <!-- Mustafijur: 13-05-2026 -->
                                        <div class="col-sm-3 d-flex align-items-center text-right justify-content-end">Year</div> <!-- Mustafijur: 13-05-2026 -->
                                        <div class="col-sm-9"> <!-- Mustafijur: 13-05-2026 -->
                                            <b-form-select
                                                id="start_year"
                                                name="start_year"
                                                data-vv-as="Year"
                                                :state="validateState('start_year')"
                                                v-validate="{ required: true }"
                                                aria-describedby="start_year-feedback"
                                                v-model="fData.start_year">
                                                <b-form-select-option v-for="(year, n) in years"
                                                                    :key="n" :value="year.value">
                                                    {{ year.text }}
                                                </b-form-select-option>
                                            </b-form-select>
                                            <b-form-invalid-feedback id="start_year-feedback">
                                                {{ veeErrors.first('start_year') }}
                                            </b-form-invalid-feedback>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 mb-3 company-form-box-title"> <!-- Mustafijur: 13-05-2026 -->
                                        <button type="submit" class="btn btn-primary position-static">Download</button>
                                    </div>
                                </div>
                            </b-form>
                        </div>
                    </b-tab>
                </b-tabs>

            </template>
            <template v-else>
                <lock-template ></lock-template>
            </template>
        </div>
    </div>
 </b-overlay>
</template>

<script>
import moment, {months} from 'moment';
export default {

    data() {
        const yearList = [
            { value: null, text: "Select Year..." },
            { value: moment().year(), text: moment().year().toString() },
            { value: moment().subtract(1, 'year').format('YYYY'), text: moment().subtract(1, 'year').format('YYYY').toString() },
        ];

        return {
            months: [
                { value: null, text: "Select Month..." },
                { value: "1", text: "January" },
                { value: "2", text: "February" },
                { value: "3", text: "March" },
                { value: "4", text: "April" },
                { value: "5", text: "May" },
                { value: "6", text: "June" },
                { value: "7", text: "July" },
                { value: "8", text: "August" },
                { value: "9", text: "September" },
                { value: "10", text: "October" },
                { value: "11", text: "November" },
                { value: "12", text: "December" },
            ],

            years: yearList,

            fData : {
                start_month: null,
                start_year: null
            },
            showoverlay : false
        }
    },
    methods: {
        downloadReport() {
            this.$bvToast.toast('It might take a while', {title: `Info`,variant: 'info',solid: true});
            this.showoverlay = true;
            let formData = new FormData();

            formData.append('download', 1);

            const config = {
              headers: { 'Content-Type': 'application/json; charset=utf-8', },
              responseType: 'blob',
            }

            axios.post(this.$api_url+'/download-kpi-report', formData, config)
                .then(function (response)
                {
                    this.showoverlay = false;
                    if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                          let err_obj = JSON.parse(`${value}`);
                          this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                     }else{
                        this.global_download_file_content(response);
                     }

                }.bind(this))
                .catch(function (error)
                {
                    currentObj.errormsg = error.response.data.errors;
                });


        },
        getReport() {
            if(!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
            });

            let formData = new FormData();

            /*Contract effective date Start*/
            if(this.fData.start_month && this.fData.start_year){
             formData.append('month', this.fData.start_month);
             formData.append('year', this.fData.start_year);
            }
            else{
               return;
            }

            this.$bvToast.toast('It might take a while', {title: `Info`,variant: 'info',solid: true});
            this.showoverlay = true;
            /*Contract effective date End*/

            const config = {
              headers: { 'Content-Type': 'application/json; charset=utf-8', },
              responseType: 'blob',
            }
            axios.post(this.$api_url+'/download-kpi-monthly-report', formData, config)
                .then(function (response)
                {
                    this.showoverlay = false;
                    if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                          let err_obj = JSON.parse(`${value}`);
                          this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                     }else{
                        this.global_download_file_content(response);
                     }

                }.bind(this))
                .catch(function (error)
                {
                    currentObj.errormsg = error.response.data.errors;
                });
        },
    }
}
</script>
